import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import { useHistory } from "react-router-dom";
import TabNavigations from "../../../../api/footer/TabNavigations";
import "./styles/footer.css";

const useStyles = makeStyles({
  root: {
    width: "100%",
    borderTop: "1px solid #eee",
  },
  dark: {
    width: "100%",
    backgroundColor: "#383838",
    borderTop: "1px solid #5d5d5d",
  },
});

const Footer = ({ theme }) => {
  let history = useHistory();

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <div className="footer-mob">
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        showLabels
        className={theme.isDarkTheme ? classes.dark : classes.root}
      >
        {TabNavigations.map((tabNavigation, index) => {
          if (tabNavigation.disabled) {
            return null;
          }

          return (
            <BottomNavigationAction
              className={`tab-navigation ${theme.isDarkTheme && "dark"}`}
              key={index}
              label={tabNavigation.title}
              icon={tabNavigation.icon}
              onClick={(e) => onChangeRoute(tabNavigation.url)}
            />
          );
        })}
      </BottomNavigation>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Footer);
